let ready = false;
let resolveReady: (() => void) | null = null;

const readyPromise = new Promise<void>((resolve) => {
  resolveReady = resolve;
});

export const isAppReady = (): boolean => ready;

export const markAppReady = (): void => {
  if (ready) return;
  ready = true;
  if (resolveReady) {
    resolveReady();
  }
};

export const whenAppReady = (): Promise<void> => {
  return ready ? Promise.resolve() : readyPromise;
};
